import { DASH, formatHours, formatMoney } from "../builder/format";
import { expenseRate, expensesTotal, type ChildExpense } from "./childExtras";

interface Props {
  expenses: ChildExpense[];
  currency: string;
}

// Travel/expense lines on the change request project. Rate is the price per
// unit, so it always agrees with Price.
const ChildExpensesTable = ({ expenses, currency }: Props) => {
  if (expenses.length === 0) return null;
  return (
    <table className="table table-sm">
      <thead>
        <tr>
          <th>Description</th>
          <th>Category</th>
          <th>Quantity</th>
          <th>Rate</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        {expenses.map((e) => {
          const rate = expenseRate(e);
          return (
            <tr key={e.id}>
              <td>{e.description || DASH}</td>
              <td>{e.category || DASH}</td>
              <td>{formatHours(e.quantity)}</td>
              <td>{rate === null ? DASH : formatMoney(rate, currency)}</td>
              <td>{formatMoney(e.revenue, currency, true)}</td>
            </tr>
          );
        })}
        <tr className="font-weight-bold">
          <td colSpan={4}>Total</td>
          <td>{formatMoney(expensesTotal(expenses), currency, true)}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default ChildExpensesTable;
